import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=67c45e0e&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
import style0 from "./Detail.vue?vue&type=style&index=0&id=67c45e0e&prod&lang=scss&scoped=true"
import style1 from "./Detail.vue?vue&type=style&index=1&id=67c45e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c45e0e",
  null
  
)

export default component.exports